// eslint-disable-next-line import/no-anonymous-default-export
export default {
  LOREM_IPSUM: 'Lorem ipsum',
  //---A---//
  ACCEPT: 'Aceptar',
  ACTIONS: 'Acciones',
  ADD_FILTERS: 'Agregar filtros',
  ADVANCED: 'Avanzado',
  API_DOCUMENTATION: 'Documentación de API',
  AUTO_BRANDED_LINKS: 'Auto-Branded Links',
  APPLY: 'Aplicar',
  ALL: 'Todos',
  ANALYZE: 'Analizar',
  ANALISYS_TRACKING: 'Análisis y segumiento avanzados',
  ACCOUNT_DETAILS: 'Detalles de la cuenta',
  ACCOUNT_SETTINGS: 'Configuración de cuenta',
  APRIL: 'Abril',
  AUGUST: 'Agosto',
  ADD_TAG: 'Agregar etiqueta',
  ACTIVES: 'Activos',
  ACTIVATE: 'Activar',
  ACCESS_PLAN: 'Acceso a estadísticas detalladas',
  //---B---//
  BASIC: 'Básico',
  BACK_HALF: 'Mitad personalizada',
  BULK_SHORTERING: 'Acortamiento de URL por lote',
  BRANDED_LINKS: 'Personalización avanzada de enlaces y marcas',
  BRANDED_CUSTOM_LINKS: 'Enlaces personalizados con tu marca',
  BENEFITS_INFO_TITLE:
    'Con <span class="color-primary">nuestra</span> <br> <span class="color-secondary"> plataforma</span> podrás:',
  BENEFITS_INFO_1: 'Con nuestra plataforma de acortamiento de enlaces podrás:',
  BENEFITS_INFO_2:
    'Transforma esas URLs extensas en enlaces cortos y amigables.',
  BENEFITS_INFO_3:
    'Modifica colores, estílos y brandea los enlaces con tu marca personal.',
  BENEFITS_INFO_4:
    'Comparte códigos QR dinámicos que generen interacción con tu contenido.',
  BENEFITS_INFO_5:
    'Realiza un seguimiento de tus enlaces para optimizar estratégias.',
  BILLING_AND_USAGE: 'Facturación y uso',
  BIG_SIZE: 'Tamaño grande',
  //---C---//
  CHANGING_PLAN: 'Tu plan esta siendo cambiado',
  CHANGE_PLAN_QR: 'Actualice su plan para crear códigos QR',
  CHANGE_STATUS: 'Cambiar Estado',
  CREDITS: 'Créditos',
  CREDITS_URL: 'Créditos restantes para enlaces',
  CREDITS_QR: 'Créditos restantes para códigos QR',
  CAMPAIGN: 'Campaña',
  CLEAR_FILTERS: 'Limpiar filtros',
  CANCEL: 'Cancelar',
  CLICS: 'clics',
  CREATE: 'Crear',
  CREATE_QR_CODE: 'Crear códigos QR',
  CREATE_NEW: 'Crear nuevo',
  CREATE_URL: 'Crear URL',
  CREATE_URL_SHORT: 'Crear URL corta',
  CREATE_URL_CUSTOM: 'Crear URL personalizada',
  CREATED_LINKS: 'Enlaces creados',
  CREATED_QR_CODES: 'Códigos QR creados',
  CUSTOM: 'Personalizar',
  CUSTOM_LINKS: 'Enlaces personalizados',
  CUSTOM_BACK_HALVES: 'Mitades traseras personalizadas',
  CREATE_COPY: 'Crear una copia',
  COPY: 'Copiar',
  COPY_LINK: 'Copiar link',
  CONTENT: 'Contenido',
  COLOR: 'Color',
  CUSTOM_DOMAINS: 'Dominios personalizados',
  CURRENT_PASSWORD: 'Contraseña actual',
  CHANGE_PASSWORD: 'Cambiar contraseña',
  CONFIRM_NEW_PASSWORD: 'Confirmar nueva contraseña',
  COOKIE_PARAGRAPH: 'Aceptar cookies',
  CLEAN_ALL_FILTERS: 'Limpiar todos los filtros',
  CONVERT_LINKS: 'Convertir enlaces',
  CLIENT: 'Cliente',
  CLIENTS_INFO:
    'Algunos de los  <span class="color-primary"> clientes</span> que <span class="color-red">confían</span> en nuestro <span class="color-primary">servicio</span>',
  CLICKS_BY_TIME: 'Clics a lo largo del tiempo',
  CLICKS_BY_LOCATION: 'Clics por locación',
  COUNTRY: 'País',
  CLICKS: 'Clics',
  //---D---//
  DEACTIVATE: 'Inactivar',
  DATA_SAVED: 'Se ha guardado la información con éxito',
  DATA_UPDATED: 'Se ha actualizado la información con éxito',
  DATA_DELETED: 'Se ha eliminado la información con éxito',
  DELETE_LOGO: 'Eliminar logo',
  DECEMBER: 'Deciembre',
  DAYS_UP_TO_TODAY: 'días hasta hoy',
  DAYS_STARTING_TODAY: 'días a partir de hoy',
  DASHBOARD: 'Panel',
  DATE: 'Fecha',
  DELETE: 'Eliminar',
  DELETE_LINK: 'Eliminar enlace',
  DELETE_QR_CODE: 'Eliminar código QR',
  DELETE_PARAGRAPH_1:
    'Eliminar este enlace redirigirá a cualquiera que haga clic en él a una página de error.',
  DELETE_QR_PARAGRAPH_1:
    'Eliminar este código QR redirigirá a cualquiera que haga clic en él a una página de error.',
  DELETE_PARAGRAPH_2: 'Esta acción no se puede deshacer.',
  DELETE_PARAGRAPH_3: '¿Estás seguro que quieres eliminar este enlace?',
  DELETE_QR_PARAGRAPH_3: '¿Estás seguro que quieres eliminar este código QR?',
  DESTINATION: 'Destino',
  DESTINATION_QR: 'Ingresa el destino de tu código QR',
  DOMAIN: 'Dominio',
  DOMAINS: 'Dominios',
  DONT_HAVE_AN_ACCOUNT: '¿No tienes una cuenta?',
  DISPLAY_NAME: 'Nombre para mostrar',
  DOWNLOAD: 'Descargar',
  DOWNLOAD_JPEG: 'Descargar JPEG',
  DOWNLOAD_PNG: 'Descargar PNG',
  DOWNLOAD_YOUR_QR_CODE: 'Descargar tu código QR',
  DOWNLOAD_QR_CODE: 'Descargar código QR',
  DOMAIN_CANT_BE_CHANGED: '*El dominio no puede ser modificado una vez creado',
  //---E---//
  ERROR_HEXADECIMAL_COLOR: 'El color hexadecimal ingresado no es válido.',
  ENTER_TAG: 'Ingresa la etiqueta y presiona ENTER.',
  ELEVATE_CONECTIONS_TITLE_1: 'Eleva tus conecciones',
  ELEVATE_CONECTIONS_TITLE_2: 'con Altera',
  ELEVATE_CONECTIONS_INFO_1:
    'Crea <strong>enlaces</strong> inteligentes y <strong>códigos QR dinámicos</strong>',
  ELEVATE_CONECTIONS_INFO_2:
    'Amplifica tu presencia compartiendólos en <strong>cualquier lugar con facilidad</strong>',
  ELEVATE_CONECTIONS_INFO_3:
    'Realiza un <strong>seguimiento detallado</strong> para potenciar lo que funciona y mejorar lo que no',
  ELEVATE_CONECTIONS_INFO_4:
    '¡Haz que cada conexión cuente con la innovadora Plataforma Altera!',
  EDIT: 'Editar',
  EDIT_LINK: 'Editar enlace',
  EMAIL: 'Correo electrónico',
  EMAIL_USERNAME_OR_PASSWORD_INCORRECT:
    'Email/usuario o contaseña es incorrecta. Por favor intente de nuevo.',
  EG_GOOGLE_NEWSLETTER: 'ej. google',
  EG_BANNER_EMAIL: 'ej. banner, email',
  EG_BLACK_FRIDAY: 'ej. viernes negro',
  EG_SOMETHING: 'ej. algo',
  EG_SOMETHING_ELSE: 'ej. algo más',
  EDIT_QR_CODE: 'Editar código QR',
  EXPORT_CSV: 'Exportar .csv',
  EDIT_LOGO: 'Editar logo',
  ERROR: 'Ha ocurrido un error, por favor comuníquese con el administrador',
  ENTER_URL_BEFORE_ACTIVATING_QR_CODE:
    'Por favor, ingrese una URL antes de seleccionar esta opción',
  EMAIL_PRIORITY: 'Soporte prioritario por correo electrónico',
  EMAIL_SUPPORT: 'Soporte por correo electrónico',
  //---F---//
  FREE: 'Gratis',
  FEBRAURY: 'Febrero',
  FILTERS: 'Filtros',
  FILTER_BY_DATE: 'Filtrar por fecha',
  FILL_VALUES: 'Por favor ingrese los datos',
  FILL_TAGS: 'Por favor ingrese las etiquetas',
  FROM: 'desde',
  //---G---//
  GET_A_QUOTE: 'Cotiza aquí',
  GET_STARTED: 'Comenzar',
  GET_STARTED_FOR_FREE: 'Comenzar gratis',
  GO_TO_QR_CODES: 'Ir a códigos QR',
  GO_TO_LINKS: 'Ir a enlaces',
  GO_TO_LINK: 'Ir al enlace',
  GO_BACK_LINKS: '< Volver a lista de links',
  GO_BACK_QRS: '< Volver a lista de códigos QR',
  //---H---//
  HAVE_AN_ACCOUNT: '¿Ya tienes una cuenta?',
  HELP: 'Ayuda',
  HOME: 'Principal',
  HIGH_QUALITY: 'Alta calidad',
  //---I---//
  INTERACTIONS_BY_REFERRAL: '<strong>Interacciones</strong><br> por referente',
  INTERACTIONS_TOTAL: 'Total de interacciones',
  INCLUDE_FILTERS: 'Incluir filtros',
  INACTIVES: 'Inactivos',
  //---J---//
  JANUARY: 'Enero',
  JUNE: 'Junio',
  JULY: 'Julio',
  //---K---//

  //---L---//
  LABELS: 'Etiquetas',
  LAST_MONTH: 'Mes Pasado',
  LAST_WEEK: 'Semana Pasada',
  LINK: 'Enlace',
  LINKS: 'Enlaces',
  LINKS_REDIRECT: 'Redireccionamiento de enlaces',
  LINKS_CLICKS: 'Clics en enlaces ilimitados',
  LINKS_EXPORT: 'Exportación de enlaces',
  LINKS_WITH_CUSTOM_BACK_HALVES: 'Enlaces con mitades traseras personalizadas',
  LINKS_WITHOUT_CUSTOM_BACK_HALVES:
    'Enlaces sin mitades traseras personalizadas',
  LINK_DETAIL: 'Detalle del link',
  LOGIN: 'Iniciar sesión',
  LOGOUT: 'Cerrar sesión',
  LOG_IN_WITH_GOOGLE: 'Inicia sesión con Google',
  LOADING: 'Cargando',
  LOGO: 'Logo',
  LOGIN_AFTER_CHANGE_PASSWORD:
    'Se le pedirá que inicie sesión después de cambiar la contraseña',
  LOW_QUALITY: 'Baja calidad',
  LINK_COPIED: 'Tu URL ha sido copiada con éxito',
  LIMITED_ACCESS: 'Acceso limitado a herramientas de personalización',
  //---M---//
  MAY: 'Mayo',
  MARCH: 'Marzo',
  MEDIUM: 'Medio',
  MONTH: 'Mes',
  MOST_POPULAR: 'Más popular',
  MY_LONG_URL: 'Mi url larga',
  MY_CUSTOM_URL: 'Enlace personalizado',
  MOBILE_DEEP_LINKS: 'Enlaces a móviles',
  //---N---//
  NO_DATA_AVAILABLE: 'No hay información',
  NAME: 'Usuario',
  NO_TAGS: 'Sin etiquetas',
  NEW_PASSWORD: 'Nueva contraseña',
  NOVEMBER: 'Noviembre',
  NO_DATA: 'No hay información disponible',
  //---Ñ---//

  //---O---//
  OR: 'O',
  ORIGINAL_LINK: 'URL original',
  OPTIONAL: 'opcional',
  OCTOBER: 'Octubre',
  //---P---//
  PLAN_CHANGED: 'Su plan ha sido cambiado',
  PLAN: 'Plan',
  PLANS: 'Ver planes',
  PAY_ANNUALY: 'Pago anual',
  PAY_MONTHLY: 'Pago mensual',
  PASSWORD: 'Contraseña',
  PRICING: 'Precios',
  PRODUCTS: 'Productos',
  PROFESSIONAL: 'Profesional',
  PREVIEW: 'Vista previa',
  PREVIEW_QR_CODE: '*Esta es una muestra de tu código QR',
  PROFILE: 'Perfil',
  PREFERENCES: 'Preferencias',
  PASSWORD_DO_NOT_MATCH: 'Contraseñas no coinciden',
  PASSWORD_RULES_1:
    'Contraseña: 8+ caracteres, 1 mayúscula, 1 minúscula, 1 número,',
  PASSWORD_RULES_2: '1 carácter especial (por ej. !, @, #, $), sin espacios.',
  PASSWORD_RULE:
    'La contraseña debe contener: 8+ caracteres, 1 mayúscula, 1 minúscula, 1 número,1 carácter especial (por ej. !, @, #, $), sin espacios',
  PERCENTAGE: 'Porcentaje',
  POPULAR_FUNCTIONS: 'Funciones populares',
  //---Q---//
  QR_CREATED: '¡Tu QR ha sido creado con éxito!',
  QR_CODE: 'Código QR',
  QR_CODES: 'Códigos QR',
  QR_CODE_INFO:
    'Generar un código QR para <strong>compartir en cualquier lugar</strong> y que <strong>las personas puedan escanearlo</strong>',
  QR_CUSTOMIZABLE: 'Códigos QR totalmente personalizables',
  QR_DYNAMIC: 'Códigos QR dinámicos',
  QR_TYPES: 'Tipos de códigos QR y opciones de destino',
  QR_CODE_COLOR: 'Color de código',
  QR_CODE_DETAIL: 'Detalle del Qr',
  QR_CODE_CHARACTERISTICS:
    '*Archivo tipo:PNG. Aspecto 1:1. Tamaño max:5MB, 2500x2500px',
  QR_WARNING_CREATION:
    '*Ten en cuenta el contraste de colores para evitar problemas al momento de escanear tu código.',
  QR_CODE_LOGO_INFO:
    '*Usa tu propia imagen de logotipo .png, .jpg, .gif o .svg Formato de archivo de tamaño máximo de 2 MB.',
  QR_CODE_UPDATE_INFO:
    '*La URL corta no puede ser cambiada una vez creado el código QR',
  QR_CODE_EDIT: 'Editar color de código',
  //---R---//
  REVIEW_LINKS: 'Puedes verlo visitando tu <strong> página de enlaces</strong>',
  REDIRECT: 'Redireccionar',
  REGISTER: 'Registro de usuario',
  RESOURCES: 'Recursos',
  REGISTER_FIRST_URL: 'Regístrate para obtener tu URL corta',
  REGISTER_FIRST_QR: 'Regístrate para obtener tu código',
  REPORTS: 'Informes mensuales de rendimiento',
  //---S---//
  SELECT: 'Selecciona',
  SELECT_URL: 'Por favor, selecciona los links',
  SELECT_ALL: 'Seleccionar todo',
  START_HERE: 'Comienza aquí',
  SAVE: 'Guardar',
  SETTINGS: 'Ajustes',
  SEE_HERE: 'Ver aquí',
  SELECT_TAG: 'Seleccione etiqueta',
  START: 'Inicio de sesión',
  SHOW: 'Mostrar',
  SHORT_LINK: 'Enlace corto',
  SHOW_PASSWORD: 'Mostrar contraseña',
  SIGN_UP: 'Registrarse',
  SUPPORT: 'Soporte',
  SOURCE: 'Origen',
  SHORT_URL_SCALE: 'Acortamiento de URL a escala',
  SHOW_LOGO_COMPANY: 'Mostrar logo Altera',
  SECURITY_AND_AUTHENTICATION: 'Seguridad y autenticacion',
  SELECT_FORMAT: 'Por favor seleccione un formato',
  SEARCH: 'Buscar',
  SEPTEMBER: 'Septiembre',
  SMALL_SIZE: 'Tamaño chico',
  SCAN_BY_TIME: 'Scan a lo largo del tiempo',
  SCAN_BY_LOCATION: 'Scan por locación',
  SCAN: 'Scans',
  STATUS_CHANGED: 'Estado cambiado exitosamente',
  STATISTICS: 'Estadísticas',
  SUPPORT_24_7: 'Soporte 24/7',
  //---T---//
  TAGS_ADDED: 'Etiquetas agregadas exitosamente',
  TAGS: 'Etiquetas',
  THIS_MONTH: 'Este Mes',
  THIS_WEEK: 'Esta Semana',
  TERMS_AND_CONDITIONS: 'Términos y condiciones',
  TITLE: 'Título',
  TODAY: 'Hoy',
  TYPES: 'Tipos',
  TERM: 'Término',
  TRANSPARENT_BACKGROUND: 'Fondo transparente',
  TODAY_STATISTICS: 'Estadísticas de hoy',
  TOTAL: 'Total',
  TO: 'hasta',
  //---U---//
  URL_IS_BEING_CREATED: 'Tu URL está siendo creada',
  URL_SHORT: 'URL corta',
  URL_CREATED: '¡Tu URL ha sido creada con éxito!',
  USER: 'Usuario',
  UNLIMITED: 'Ilimitados',
  URL_TYPE: 'Tipo de URL',
  USER_REGISTER_SUCCESSFULL: 'Usuario registrado con éxito',
  USER_ALREADY_EXIST: 'Usuario ya existe',
  USER_ALREADY_EXIST_GO_TO_THE_LOGIN:
    'Usuario ya existe, por favor ir al inicio',
  USER_DO_NOT_EXIST: 'Usuario no existe',
  USER_DO_NOT_EXIST_PLEASE_SIGN_UP: 'Usuario no existe, por favor regístrese',
  UTM: 'Datos de UTM',
  UTM_INFO:
    'Agregar <strong>UTM</strong> para <strong>rastrear el tráfico web</strong> en herramientas de análisis',
  UTM_TAG_PREVIEW: 'Vista previa de etiquetas UTM',
  UTM_TAG_PREVIEW_QUESTION:
    'Así aparecerán tus parámetros UTM al final de tu URL de destino',
  UPDATE: 'Actualizar',
  UPDATE_PLAN: 'Cambiar de plan',
  UPDATE_PASSWORD: 'Actualizar contraseña',
  UPLOAD_YOUR_LOGO: 'Sube tu logo',
  USER_NOT_FOUND: 'Usuario no autorizado',

  //---V---//
  VIEW_LINK_DETAIL: 'Ver detalle de enlace',
  VIEW_QR_CODE_DETAIL: 'Ver código QR',
  VIEW_DETAIL: 'Ver detalle',
  //---W---//
  WHAT_CREATE: '¿Qué te gustaría <span class="color-primary">crear<span>?',
  WAYS_TO_SHARE: 'Formas de compartir',
  WHY_ALTERA: 'Por qué Altera',
  WELCOME_TO_ALTERA:
    '¡Bienvenido a <span class="color-secondary">Altera Links</span>!',
  WELCOME_TO_ALTERA_INFO_1:
    '<strong>¿Cansado de enlaces largos y complicados?</strong> ¡Nosotros tenemos la solución perfecta para tí!',
  WELCOME_TO_ALTERA_INFO_2:
    'En Altera, te ofrecemos una herramienta de <strong>acortamiento URL</strong> de vanguardia, diseñada para <strong>simplificar y potenciar</strong> tus conexiones en línea.',

  //---X---//

  //---Y---//
  YES_DELETE: 'Si, quiero eliminar',
  YESTERDAY: 'Ayer',
  YEAR: 'Año',
  YOUR_SETTINGS: 'Tu configuración',
  YOUR_CREATIONS: 'Tus creaciones',
  //---Z---//
}
